import * as z from "zod/v4";

export const updateBaseShopperAgentSettings = {
  name: "updateBaseShopperAgentSettings" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    /**
     * Set to `true` only by the text-concierge onboarding flow. When set
     * alongside `enabled: true`, the handler also enables Support AI, grants
     * the Support AI trial, creates the concierge automation, and turns on
     * `replyConfig.enabled` — i.e. the full "onboard a merchant to text
     * concierge" bundle. Other UI surfaces that toggle the shopper agent
     * (playbook, landing, settings) must omit this so a normal toggle
     * doesn't silently flip Support AI on.
     */
    bootstrapSupport: z.boolean().optional(),
    iMessageConfig: z.object({ enabled: z.boolean().optional() }).optional(),
    personaConfig: z
      .object({ enabled: z.boolean().optional(), name: z.string().optional() })
      .optional(),
    recoverConfig: z.object({ enabled: z.boolean().optional() }).optional(),
    replyConfig: z.object({ enabled: z.boolean().optional() }).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
